import React from "react";
import { FaPhoneAlt, FaWhatsapp, FaEnvelope, FaInstagram, FaRegCopyright } from "react-icons/fa";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-row">
        <a href="tel:+919492076737" className="footer-link">
          <FaPhoneAlt className="footer-icon" /> +91 9492076737
        </a>

        <a
          href="https://wa.me/919492076737"
          target="_blank"
          rel="noopener noreferrer"
          className="footer-link">
          <FaWhatsapp className="footer-icon" /> WhatsApp
        </a>

         <a
          href="mailto:contact.aesthetictales@gmail.com"
          target="_blank"
          rel="noopener noreferrer"
          className="footer-link">
          <FaEnvelope className="footer-icon" /> contact.aesthetictales@gmail.com
        </a>

        <a
          href="https://www.instagram.com/aesthetictales_by_navaneeth"
          target="_blank"
          rel="noopener noreferrer"
          className="footer-link">
          <FaInstagram className="footer-icon" /> @aesthetictales_by_navaneeth
        </a>

        <span className="footer-copy">
          <FaRegCopyright className="footer-icon" /> 2025 All Rights Reserved
        </span>
      </div>
    </footer>
  );
};

export default Footer;
